import { apiSlice, publicApiSlice } from "../../apiSlice";
import { createActivityApi } from "./createActivityApi";

// Create both private and public API slices
export const activityApiSlice = createActivityApi(apiSlice);
export const publicActivityApiSlice = createActivityApi(publicApiSlice);

// Export hooks for private API
export const {
	useGetActivitiesByProjectQuery,
	useUpdateActivityMutation,
	useCreateActivityMutation,
	useCreateBIntactActivityMutation,
	useDeleteActivityMutation,
	useGetActivitiesByIdQuery,
	useCreateActivityCopyMutation,
	useGetModulesByActivityIdQuery,
	useLazyGetModulesByActivityIdQuery,
	useGetModulesStatuesQuery,
	useGetActivityResultsQuery,
	useGetFastActivitiesByProjectQuery,
	useLazyGetFastActivitiesByProjectQuery,
	useLazyGetActivitiesByIdQuery,
	endpoints,
} = activityApiSlice;

// Export hooks for public API - only read operations
export const {
	useGetActivitiesByProjectQuery: usePublicGetActivitiesByProjectQuery,
	useGetActivitiesByIdQuery: usePublicGetActivitiesByIdQuery,
	useGetModulesByActivityIdQuery: usePublicGetModulesByActivityIdQuery,
	useLazyGetModulesByActivityIdQuery: useLazyPublicGetModulesByActivityIdQuery,
	useGetModulesStatuesQuery: usePublicGetModulesStatuesQuery,
	useGetActivityResultsQuery: usePublicGetActivityResultsQuery,
	useGetFastActivitiesByProjectQuery: usePublicGetFastActivitiesByProjectQuery,
	useLazyGetFastActivitiesByProjectQuery: useLazyPublicGetFastActivitiesByProjectQuery,
} = publicActivityApiSlice;
